// ASTT-7178: shared roster-status color coding, used by ClassDetails.js
// (both the multi-select's dropdown options and selected chips) for
// whichever domain is currently active -- Hand Off (by ReportTypeId) or
// Training Notes (by DTR Date). Both domains use the same underlying
// Draft/Sent status values, so one shared color map and one shared
// legend cover both rather than duplicating either per domain.
//
// Colors intentionally match TrainingNotes.js's own existing calendar-
// highlight colors (DateLegendActionBar/renderDay) exactly -- once this
// picker and that calendar can appear on the same Training Notes screen,
// showing a different shade for the same word ("Draft") in two places
// would be a real inconsistency, not just a missed reuse opportunity.
export const ROSTER_STATUS_COLORS = {
  Draft: "#FFF4D6",
  Sent: "#DCF5E0",
};

// Border colors, used only by the legend swatches below -- the picker's
// own option/chip backgrounds don't currently carry a border, so this
// stays scoped to the legend rather than changing that existing look.
export const ROSTER_STATUS_BORDER_COLORS = {
  Pending: "#d3d3d3",
  Draft: "#E0A800",
  Sent: "#2AA154",
};

export const ROSTER_STATUS_LEGEND_ITEMS = [
  { status: "Pending", label: "Pending" },
  { status: "Draft", label: "Draft" },
  { status: "Sent", label: "Sent" },
];

// Resolves which status field to read off a roster option/chip object,
// and which color to apply, for whichever domain is currently active.
// "handoff" reads option.handOffStatus (set by fetchRosterData when
// reportTypeId was passed); "trainingNotes" reads option.dtrStatus (set
// when dtrDate was passed). Returns undefined for a null mode or an
// unrecognized status (e.g. "Pending"), which callers treat as "no
// background override" -- the option/chip's plain default look.
export const getRosterStatusBackground = (statusMode, option) => {
  if (!statusMode || !option) return undefined;
  const status =
    statusMode === "handoff"
      ? option.handOffStatus
      : statusMode === "trainingNotes"
        ? option.dtrStatus
        : undefined;
  return ROSTER_STATUS_COLORS[status];
};
